import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';
import CurrentPage from '@frontend/app/features/CurrentPage';

export default class extends Controller {
  connect() {
    document.addEventListener(
      'track-metrics-action:track',
      this.handleTrack.bind(this)
    );
  }

  track({ params: { name, options } }) {
    this.trackAction(name, options);
  }

  handleTrack(event) {
    const name = event.detail.name;
    const options = event.detail.options;

    this.trackAction(name, options);
  }

  trackAction(name, options = {}) {
    const body = JSON.stringify({
      metrics_action: { name: name, options: options },
    });
    post(CurrentPage.getTrackMetricsActionPath(), { body: body });
  }
}

export function trackAction(name, options = {}) {
  document.body.dispatchEvent(
    new CustomEvent('track-metrics-action:track', {
      bubbles: true,
      detail: {
        name: name,
        options: options,
      },
    })
  );
}
